import { __decorate } from "tslib";
import { Vue, Component, Prop } from "../../vue";
import { Modal, message } from 'ant-design-vue';
import { isRequiredSchema } from "../../core/common/isRequiredSchema";
import { schemaEach } from "../../core/common/schemaUtil";
import { openSchemaCreateModal, openSchemaEditModal } from "./SchemaEditView";
import styles from "./style.module.css";
export const iconStyle = {
  marginLeft: '6px',
  color: 'rgb(45, 183, 245)'
};
export const btnsStyle = {
  display: 'inline-block',
  marginRight: '6px'
};
export const tagStyle = {
  width: '60px',
  textAlign: 'center'
};
export const titleStyle = {
  marginLeft: '4px'
};
/**
 * 用于展示shecma json 树状结构
 */
let SchemaTreeView = class SchemaTreeView extends Vue {
  constructor() {
    super(...arguments);
    this.showSchema = null;
    this.currentCtx = null;
    this.isShowEdit = false;
  }
  get isUseMouseEvent() {
    return this.editable || this.selectable;
  }
  get titleClassName() {
    return this.editable ? styles.canClick : '';
  }
  onMouseenter(schema, ctx) {
    if (!this.isUseMouseEvent) return;
    this.showSchema = schema;
    this.currentCtx = ctx;
  }
  onMouseleave(schema, _ctx) {
    if (!this.isUseMouseEvent) return;
    if (this.showSchema === schema) {
      this.showSchema = null;
      this.currentCtx = null;
    }
  }
  async onEdit() {
    var _this$currentCtx;
    if (!this.showSchema) return;
    await openSchemaEditModal({
      schema: this.showSchema,
      isItems: ((_this$currentCtx = this.currentCtx) === null || _this$currentCtx === void 0 ? void 0 : _this$currentCtx.isItems) || false,
      title: '编辑字段定义',
      disabledFields: !this.rootIdEditable && this.showSchema === this.schema ? ['id'] : []
    });
    this.$emit('update:schema', this.schema);
  }
  onDel() {
    const {
      showSchema,
      currentCtx
    } = this;
    if (!(showSchema !== null && showSchema !== void 0 && showSchema.id)) {
      return;
    }
    Modal.confirm({
      title: '注意',
      content: `确定要删除${showSchema === null || showSchema === void 0 ? void 0 : showSchema.id}字段吗`,
      okText: '删除',
      cancelText: '取消',
      onOk: () => {
        var _parent$fields;
        console.log('删除');
        const parent = currentCtx === null || currentCtx === void 0 ? void 0 : currentCtx.parentSchema;
        if (!parent) return;
        const index = (_parent$fields = parent.fields) === null || _parent$fields === void 0 ? void 0 : _parent$fields.findIndex(item => item === showSchema);
        if (typeof index === 'number' && index > -1) {
          var _parent$fields2;
          (_parent$fields2 = parent.fields) === null || _parent$fields2 === void 0 || _parent$fields2.splice(index, 1);
          this.$emit('update:schema', this.schema);
        }
      }
    });
  }
  async onAdd() {
    var _this$currentCtx2, _showSchema$fields;
    const {
      showSchema
    } = this;
    if (!showSchema || showSchema.type !== 'object') return;
    const res = await openSchemaCreateModal({
      isItems: ((_this$currentCtx2 = this.currentCtx) === null || _this$currentCtx2 === void 0 ? void 0 : _this$currentCtx2.isItems) || false,
      title: '创建字段定义'
    });
    if (!res.success || !res.schema) return;
    const isOk = Array.isArray(showSchema === null || showSchema === void 0 ? void 0 : showSchema.fields) ? showSchema === null || showSchema === void 0 || (_showSchema$fields = showSchema.fields) === null || _showSchema$fields === void 0 ? void 0 : _showSchema$fields.every(item => {
      var _res$schema;
      return item.id !== ((_res$schema = res.schema) === null || _res$schema === void 0 ? void 0 : _res$schema.id);
    }) : true;
    if (isOk) {
      if (!showSchema.fields) {
        this.$set(showSchema, 'fields', []);
      }
      showSchema === null || showSchema === void 0 || showSchema.fields.push(res.schema);
      this.$emit('update:schema', this.schema);
    } else {
      message.error(`${res.schema.id} 字段已经存在，无法重复添加`);
    }
  }
  onSetKey() {
    const {
      showSchema
    } = this;
    if (!showSchema) return;
    if (showSchema !== null && showSchema !== void 0 && showSchema.isPrimaryKey) {
      Vue.delete(showSchema, 'isPrimaryKey');
    } else {
      this.clearKey();
      Vue.set(showSchema, 'isPrimaryKey', true);
    }
  }
  /**
   * 清楚主键
   */
  clearKey() {
    const {
      schema
    } = this;
    schemaEach(schema, s => {
      if (s.isPrimaryKey) {
        Vue.delete(s, 'isPrimaryKey');
      }
    });
  }
  selectSchema() {
    if (!this.showSchema) {
      return;
    }
    this.$emit('select', this.showSchema); //
  }
  getNodeTitle(schema, ctx) {
    const {
      isItems,
      parentSchema
    } = ctx;
    const title = isItems ? `${(parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.id) || ''} 数组子项` : [schema.id, schema.title].filter(Boolean).join('-');
    return title;
  }
  renderEdit() {
    const h = this.$createElement;
    const {
      showSchema,
      currentCtx
    } = this;
    const items = [...((showSchema === null || showSchema === void 0 ? void 0 : showSchema.type) === 'object' ? [{
      type: 'file-add',
      title: '添加字段',
      click: this.onAdd
    }] : []), ...(showSchema !== null && showSchema !== void 0 && showSchema.id && currentCtx !== null && currentCtx !== void 0 && currentCtx.parentSchema ? [{
      type: 'delete',
      title: '删除',
      click: this.onDel
    }] : []), ...(showSchema !== null && showSchema !== void 0 && showSchema.id && ['string', 'number'].includes((showSchema === null || showSchema === void 0 ? void 0 : showSchema.type) || '') && this.primaryKeyEditable ? [{
      type: 'key',
      title: `${showSchema !== null && showSchema !== void 0 && showSchema.isPrimaryKey ? '删除' : '设置为'}主键`,
      click: this.onSetKey
    }] : [])];
    return items.map(item => {
      const icon = h("a-icon", {
        "attrs": {
          "type": item.type
        },
        "key": item.type,
        "style": iconStyle,
        "on": {
          "click": item.click
        }
      });
      return h("a-tooltip", {
        "attrs": {
          "title": item.title
        }
      }, [icon]);
    });
  }
  renderEditFiled() {
    const h = this.$createElement;
    const item = {
      type: 'edit',
      title: '编辑',
      click: this.onEdit
    };
    const icon = h("a-icon", {
      "attrs": {
        "type": item.type
      },
      "key": item.type,
      "style": iconStyle,
      "on": {
        "click": item.click
      }
    });
    return h("a-tooltip", {
      "attrs": {
        "title": item.title
      }
    }, [icon]);
  }
  renderSelect() {
    const h = this.$createElement;
    const icon = h("a-icon", {
      "attrs": {
        "type": "copy",
        "theme": "filled"
      },
      "style": iconStyle,
      "on": {
        "click": this.selectSchema
      }
    });
    return h("a-tooltip", {
      "attrs": {
        "title": this.selectTitle
      }
    }, [icon]);
  }
  renderOptionalTag(id) {
    const h = this.$createElement;
    if (!this.optionalTags) return null;
    const tagOption = this.optionalTags[id];
    if (!tagOption) return null;
    return tagOption.map(({
      color,
      tag,
      desc
    }) => {
      if (!desc) return h("a-tag", {
        "attrs": {
          "color": color || '#87d068'
        }
      }, [tag]);
      return h("a-popover", [h("template", {
        "slot": "content"
      }, [h("span", [desc])]), h("a-tag", {
        "attrs": {
          "color": color || '#87d068'
        }
      }, [tag])]);
    });
  }
  renderTitle(schema, ctx) {
    const h = this.$createElement;
    const {
      isItems
    } = ctx;
    const title = this.getNodeTitle(schema, ctx);
    const isRequired = isRequiredSchema(schema);
    const isHit = this.showSchema === schema;
    const isShowEdit = this.editable && isHit;
    const isShowSelect = this.selectable && isHit;
    const titleSpan = this.editable ? h("a-tooltip", {
      "attrs": {
        "title": "点击可编辑"
      }
    }, [h("span", {
      "style": titleStyle,
      "on": {
        "click": this.onEdit
      },
      "class": this.titleClassName
    }, [title])]) : h("span", {
      "style": titleStyle
    }, [title]);
    const titleSlot = h("div", {
      "slot": "title",
      "on": {
        "mouseenter": () => this.onMouseenter(schema, ctx),
        "mouseleave": () => this.onMouseleave(schema, ctx)
      }
    }, [schema.type && h("a-tag", {
      "style": tagStyle,
      "attrs": {
        "color": isItems ? 'purple' : 'blue'
      }
    }, [schema.type]), !isRequired && h("a-tag", {
      "attrs": {
        "color": "green"
      }
    }, ["\u53EF\u9009"]), schema.isPrimaryKey && h("a-tag", {
      "attrs": {
        "color": "#108ee9"
      }
    }, ["\u4E3B\u952E"]), this.renderOptionalTag(schema.id), h("span", {
      "directives": [{
        name: "show",
        value: this.editable
      }],
      "style": btnsStyle
    }, [isShowEdit && this.renderEdit()]), h("span", {
      "directives": [{
        name: "show",
        value: this.selectable
      }],
      "style": btnsStyle
    }, [isShowSelect && this.renderSelect()]), titleSpan]);
    return titleSlot;
  }
  renderTreeNode(schema, ctx = {
    isItems: false
  }) {
    var _schema$fields;
    const h = this.$createElement;
    if (!schema) {
      return null;
    }
    return h("a-tree-node", {
      "key": schema.id
    }, [(_schema$fields = schema.fields) === null || _schema$fields === void 0 ? void 0 : _schema$fields.map(f => this.renderTreeNode(f, {
      parentSchema: schema,
      isItems: false
    })), schema.items && this.renderTreeNode(schema.items, {
      parentSchema: schema,
      isItems: true
    }), this.renderTitle(schema, ctx)]);
  }
  render() {
    const h = arguments[0];
    return h("div", [h("a-tree", {
      "attrs": {
        "showLine": true,
        "defaultExpandAll": this.defaultExpandAll,
        "selectable": false,
        "showIcon": false
      },
      "class": styles.stv
    }, [h("a-icon", {
      "slot": "switcherIcon",
      "attrs": {
        "type": "down"
      }
    }), this.renderTreeNode(this.schema)])]);
  }
};
__decorate([Prop()], SchemaTreeView.prototype, "schema", void 0);
__decorate([Prop({
  default: false
})], SchemaTreeView.prototype, "defaultExpandAll", void 0);
__decorate([Prop({
  default: false
})], SchemaTreeView.prototype, "editable", void 0);
__decorate([Prop({
  default: true
})], SchemaTreeView.prototype, "primaryKeyEditable", void 0);
__decorate([Prop({
  default: true
})], SchemaTreeView.prototype, "rootIdEditable", void 0);
__decorate([Prop({
  default: false
})], SchemaTreeView.prototype, "selectable", void 0);
__decorate([Prop({
  default: '选择schema节点'
})], SchemaTreeView.prototype, "selectTitle", void 0);
__decorate([Prop()], SchemaTreeView.prototype, "optionalTags", void 0);
SchemaTreeView = __decorate([Component({
  name: 'SchemaTreeView'
})], SchemaTreeView);
export default SchemaTreeView;
//# sourceMappingURL=SchemaTreeView.js.map
